/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scan_MealInputs */

const en_portal_scan_meal = /** @type {(inputs: Portal_Scan_MealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunch · recognised from a photo`)
};

const pl_portal_scan_meal = /** @type {(inputs: Portal_Scan_MealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiad · rozpoznany ze zdjęcia`)
};

/**
* | output |
* | --- |
* | "Lunch · recognised from a photo" |
*
* @param {Portal_Scan_MealInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_scan_meal = /** @type {((inputs?: Portal_Scan_MealInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scan_MealInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_scan_meal(inputs)
	return en_portal_scan_meal(inputs)
});